import { render, staticRenderFns } from "./TheTable.vue?vue&type=template&id=46d1d4f4&scoped=true&"
import script from "./TheTable.vue?vue&type=script&lang=js&"
export * from "./TheTable.vue?vue&type=script&lang=js&"
import style0 from "./TheTable.vue?vue&type=style&index=0&id=46d1d4f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1d4f4",
  null
  
)

export default component.exports